import React from "react";

const IconElastic: React.FC = () => {
  return (
    <svg
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 79.22 69.46"
      stroke="currentColor"
      strokeWidth={6}
    >
      <path
        className="cls-1"
        d="m3,44.48S4.48,3,9.42,3s6.58,63.46,12.01,63.46,4.94-34.21,10.04-34.21,5.43,18.61,9.38,18.61,5.92-10.1,8.56-10.1,4.61,5.32,7.4,5.32,4.94-2.84,6.58-2.84,4.28,1.95,6.75,1.95,4.28-1.06,6.09-1.06"
      />
    </svg>
  );
};

export default IconElastic;
